export default __webpack_public_path__ + "images/G8.fb45259.png";